<template>
	<div class="forget">
		<div class="forget-line">
			<span>
				请输入新密码：
			</span>
			<el-input type="password" v-model="password" placeholder="请输入新密码"></el-input>
		</div>
		<div class="submit">
			<el-button type="success" :loading="loading" icon="el-icon-check" @click="submit">
				确认修改
			</el-button>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'forget',
		data() {
			return {
				password:'',
				loading:false
			};
		},
		methods: {
			...mapMutations(['logout']),
			submit(){
				if (!this.$ver.verify_password(this.password)) {
					this.$message({
						type: 'error',
						message: '请输入6-18位密码。'
					})
					return
				}
				this.loading = true
				this.$api.changePassword({
					password:this.password
				},res=>{
					this.loading = false
					if(res.code==200){
						this.$api.resetHeader()
						this.$message({
							message: '修改密码成功，请重新登陆！',
							type: 'success',
							duration: 2000,
							onClose: () => {
								this.logout()
							}
						});
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.forget-line,.submit{
		width: 500px;
		height: 80px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
		.el-input{
			width: 350px;
		}
		.el-button{
			width: 350px;
		}
	}
	.forget{
		padding-top: @vue-spacing-col-lg*4;
	}
</style>
